import React, {useEffect, useState,useRef, forwardRef} from 'react';
import Box from "@mui/material/Box";
import {useSelector} from "react-redux";
import {
    Button,
    FormControl,
    Grid,
    MenuItem,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow, Typography
} from "@mui/material";
import moment from "moment/moment";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import {MenuProps} from "../../calender/crmCalender";
import {
    convertTimeToMinutes,
    generateYearsToday,
    getEndTime,
    getTimeSlotsArray,
    monthsArray, MySwal, successConfirmation
} from "../../../../services/utills";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import {scrollCSS} from "../../../../App";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";



const boxStyle ={
 background:"#f4ede3",
    height:'40px',
    width:'40px',
    // border:"1px solid #006AFF",
    display:'flex',
    alignItems:"center",
    borderRadius:'4px',
    justifyContent:'center',
    // color:'#006AFF',
    cursor:'pointer',
    "&:hover": {
        // background:"#006AFF",
        // color:'#fff'
    }
}
const disableStyle ={
    opacity: 0.5,
    color:'#D5D9DC',

    border:"none !important",
    "&:hover": {
        cursor: 'not-allowed'
    }
}
const dateStyle ={
    p:"10px 0",
    fontSize:'14px',
    fontWeight:'bold',
    height: '40px',
    width: '40px',
    mx: 'auto',
    border:"1px solid #E6DAD1",
    borderRadius: '50%',
}

const AppointmentTime = forwardRef(({selectedServices, getAppointmentHoliday, selectedTime, setSelectedTime, selectedStaff, getAppointmentSchedule, selectedFinalDate, executeScroll, panelMode }, ref) => {
        const currentData = new Date();

        // Initialize startDate with selectedFinalDate if it exists, otherwise use current date
        const [startDate, setStartDate] = useState(() => {
            if (selectedFinalDate) {
                const selectedDate = new Date(selectedFinalDate);
                return selectedDate >= currentData ? selectedDate : currentData;
            }
            return currentData;
        });
            useEffect(() => {
                if (selectedFinalDate) {
                    const selectedDate = new Date(selectedFinalDate);
                    setStartDate(selectedDate >= currentData ? selectedDate : currentData);
                } else {
                    setStartDate(currentData);
                }
            }, [selectedFinalDate]);

        const isCurrentMonth = (currentData.getMonth() === startDate.getMonth()) && (currentData.getFullYear() === startDate.getFullYear());
        const monthStart = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
        const monthEnd = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
        const daysInMonth = monthEnd.getDate();
        let firstDayOfWeek = monthStart.getDay();

        firstDayOfWeek = firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1; // Adjust for Monday start
        const lastDayOfWeek = monthEnd.getDay();

        const bookAppointmentStore = useSelector(state => state?.bookAppointmentStore);
        const { appointmentHolidays = [], appointmentSchedule = [] } = bookAppointmentStore;

        const scrollRef = useRef(null); // Create the ref

        // Function to execute scrolling
        const executeScrolldate = () => {
            setTimeout(() => {
                if (scrollRef.current) {
                    scrollRef.current.scrollIntoView({ behavior: "smooth" });
                }
            }, 500);
        };
        useEffect(() => {
            if (selectedTime?.start_time && selectedServices?.length > 0) {
          //console.log("selected time handel call")
                let totalTime = 0;
                selectedServices.forEach((item) => {
                    let time = convertTimeToMinutes(item?.time_duration);
                    totalTime += time;
                });
     //console.log("total time",totalTime)
                let endTime = getEndTime(selectedTime?.start_time, totalTime);
                let getArraySlots = getTimeSlotsArray(selectedTime?.start_time, endTime, appointmentSchedule?.slots);
                // let lastIndex = getArraySlots[0];
    
             
                    let object = { 
                        start_time: selectedTime?.start_time,
                        end_time: endTime,  
                        slots: getArraySlots, 
                    };
                    //console.log("slotsArray object",object)
                    setSelectedTime(object);
            }
        }, [selectedServices]); 

        const weeks = [];
        let days = [];

        for (let i = 0; i < firstDayOfWeek; i++) {
            days.push(
                <TableCell key={`empty-${i}`} sx={{ p: "0" }}>
                    <Box sx={{ width: '50px' }}>{''}</Box>
                </TableCell>
            );
        }

        for (let i = 1; i <= daysInMonth; i++) {
            const isExist = appointmentHolidays?.length > 0 && appointmentHolidays.some((item) => parseFloat(item) === parseFloat(i));
            const formattedDate = moment(new Date(startDate.getFullYear(), startDate.getMonth(), i)).format('YYYY-MM-DD');
            const isHoliday = appointmentHolidays?.length > 0 && appointmentHolidays?.includes(formattedDate);
            const isPast = isCurrentMonth && i < currentData.getDate();
            const isDisabledDate = isPast || isHoliday;

            days.push(
                <TableCell key={i} sx={{ p: "0" }}>
                    <Box
                        sx={{
                            ...dateStyle,
                            cursor: ((isCurrentMonth && i < currentData.getDate()) || isExist || isDisabledDate) ? 'default' : 'pointer',
                            color: ((isCurrentMonth && i < currentData.getDate()) || isExist || isDisabledDate) ? "#8D8D8D" : i === moment(selectedFinalDate)?.date() && startDate.getMonth() === moment(selectedFinalDate).month() && startDate.getFullYear() === moment(selectedFinalDate).year() ? '#006AFF' : '#000',
                            pointerEvents: ((isCurrentMonth && i < currentData.getDate()) || isExist || isDisabledDate) ? "none!important" : 'auto',
                            textDecoration: ((isCurrentMonth && i < currentData.getDate()) || isExist || isDisabledDate) ? "line-through" : 'none',
                            border: ((isCurrentMonth && i < currentData.getDate()) || isExist || isDisabledDate) ? "none" : '1px solid #E6DAD1',
                         
                        }}
                        onClick={() => {
                            const date = moment(new Date(startDate.getFullYear(), startDate.getMonth(), i)).format('YYYY-MM-DD');
                            getAppointmentSchedule(date);
                            executeScrolldate();
                        }}
                    >
                        {i}
                    </Box>
                </TableCell>
            );

            if ((i + firstDayOfWeek) % 7 === 0 || i === daysInMonth) {
                weeks.push(<TableRow key={`week-${i}`}>{days}</TableRow>);
                days = [];
            }
        }

        for (let i = (lastDayOfWeek + 1) % 7; i < 6; i++) {
            days.push(
                <TableCell key={`empty-${i}`} sx={{ p: "0" }}>
                    <Box sx={{ width: '50px' }}>{''}</Box>
                </TableCell>
            );
        }

        const isDisabled = (month) => {
            const today = new Date();
            const year = today.getFullYear();
            const currentMonth = today.getMonth();
            const currentYear = startDate.getFullYear();
            if (year === currentYear) {
                return month < currentMonth;
            } else {
                return false;
            }
        };

        const handleSelectedTime = async (slotsArray, startTime) => {
            let totalTime = 0;
            selectedServices.forEach((item) => {
                let time = convertTimeToMinutes(item?.time_duration);
                totalTime += time;
            });

            let endTime = getEndTime(startTime, totalTime);
            let getArraySlots = getTimeSlotsArray(startTime, endTime, slotsArray);
            let lastIndex = getArraySlots[0];

            if (slotsArray?.includes(lastIndex)) {
                let object = {
                    start_time: startTime,
                    end_time: endTime,
                    slots: getArraySlots,
                };

                setSelectedTime(object);
                executeScroll(); // Scrolls to the reschedule button in the parent component

            } else {
                setSelectedTime(null);
                await MySwal.fire({
                    icon: 'error',
                    title: 'Invalid Time Slots.',
                    showConfirmButton: true,
                    timer: 5000,
                });
            }
        };

        if (panelMode) {
            // Build calendar cells with the redesigned look
            const panelWeeks = [];
            let panelCells = [];
            for (let i = 0; i < firstDayOfWeek; i++) {
                panelCells.push(<Box key={`empty-${i}`} sx={{ height: { xs: 38, sm: 47 } }} />);
            }
            for (let i = 1; i <= daysInMonth; i++) {
                const isExist = appointmentHolidays?.length > 0 && appointmentHolidays.some((item) => parseFloat(item) === parseFloat(i));
                const formattedDate = moment(new Date(startDate.getFullYear(), startDate.getMonth(), i)).format('YYYY-MM-DD');
                const isHoliday = appointmentHolidays?.length > 0 && appointmentHolidays?.includes(formattedDate);
                const isPast = isCurrentMonth && i < currentData.getDate();
                const dayDisabled = isPast || isHoliday || isExist;
                const isSelected = i === moment(selectedFinalDate)?.date() && startDate.getMonth() === moment(selectedFinalDate).month() && startDate.getFullYear() === moment(selectedFinalDate).year();
                panelCells.push(
                    <Box
                        key={`day-${i}`}
                        onClick={() => {
                            if (dayDisabled) return;
                            const date = moment(new Date(startDate.getFullYear(), startDate.getMonth(), i)).format('YYYY-MM-DD');
                            getAppointmentSchedule(date);
                            executeScrolldate();
                        }}
                        sx={{
                            height: { xs: 38, sm: 47 },
                            width: { xs: '100%', sm: 45 },
                            maxWidth: { xs: 38, sm: 45 },
                            mx: 'auto',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            borderRadius: '50%',
                            fontSize: { xs: '12px', sm: '13px' },
                            fontWeight: isSelected ? 700 : 500,
                            cursor: dayDisabled ? 'default' : 'pointer',
                            background: isSelected ? '#A72C68' : 'transparent',
                            color: isSelected ? '#fff' : (dayDisabled ? '#c0c4cc' : '#1a1a2e'),
                            border: !isSelected && !dayDisabled ? '1px solid #ECEDF2' : 'none',
                            textDecoration: dayDisabled ? 'line-through' : 'none',
                            pointerEvents: dayDisabled ? 'none' : 'auto',
                            transition: 'background 0.15s',
                            '&:hover': dayDisabled ? {} : { background: isSelected ? '#921F58' : '#FAEFF5' },
                        }}
                    >
                        {i}
                    </Box>
                );
                if ((i + firstDayOfWeek) % 7 === 0 || i === daysInMonth) {
                    while (panelCells.length < 7 && i === daysInMonth) {
                        panelCells.push(<Box key={`tail-${panelCells.length}`} sx={{ height: { xs: 38, sm: 47 } }} />);
                    }
                    panelWeeks.push(
                        <Box
                            key={`week-${i}`}
                            sx={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(7, 1fr)',
                                gap: { xs: '4px', sm: '10px' },
                                mt: { xs: '8px', sm: '14px' },
                            }}
                        >
                            {panelCells}
                        </Box>
                    );
                    panelCells = [];
                }
            }

            const sectionDefs = [
                { key: 'morningTimeSlots',   label: 'Morning',   icon: <WbSunnyIcon sx={{ fontSize: 14, color: '#3B82F6' }} />, bg: '#EEF4FF', color: '#3B82F6' },
                { key: 'afternoonTimeSlots', label: 'Afternoon', icon: <WbSunnyIcon sx={{ fontSize: 14, color: '#F2994A' }} />, bg: '#FFF6EC', color: '#F2994A' },
                { key: 'eveningTimeSlots',   label: 'Evening',   icon: <DarkModeIcon sx={{ fontSize: 14, color: '#A72C68' }} />, bg: '#FAEFF5', color: '#A72C68' },
            ];

            return (
                <Grid container spacing={2}>
                    {/* Left: Calendar */}
                    <Grid item xs={12}>
                        <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#1a1a2e', mb: 1.25 }}>Select Date</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1, gap: 1, flexWrap: 'wrap' }}>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                                <FormControl size="small">
                                    <Select
                                        size="small"
                                        value={startDate?.getMonth()}
                                        MenuProps={MenuProps}
                                        onChange={(e) => {
                                            const end = new Date(startDate);
                                            end.setMonth(e?.target?.value);
                                            setStartDate(end);
                                            getAppointmentHoliday(end, selectedStaff);
                                        }}
                                        sx={{
                                            background: '#F7F8FB',
                                            borderRadius: '8px',
                                            minWidth: { xs: 70, sm: 80 },
                                            fontSize: { xs: '12px', sm: '13px' },
                                            '.MuiOutlinedInput-notchedOutline': { borderColor: '#ECEDF2' },
                                            '& .MuiSelect-select': { py: { xs: '6px', sm: '8.5px' } },
                                        }}
                                    >
                                        {monthsArray?.map((item, index) => (
                                            <MenuItem disabled={isDisabled(item?.key)} value={item?.key} key={index}>{item?.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl size="small">
                                    <Select
                                        size="small"
                                        value={startDate?.getFullYear()}
                                        MenuProps={MenuProps}
                                        onChange={(e) => {
                                            const end = new Date(startDate);
                                            end.setFullYear(e?.target?.value);
                                            setStartDate(end);
                                            getAppointmentHoliday(end, selectedStaff);
                                        }}
                                        sx={{
                                            background: '#F7F8FB',
                                            borderRadius: '8px',
                                            minWidth: { xs: 70, sm: 80 },
                                            fontSize: { xs: '12px', sm: '13px' },
                                            '.MuiOutlinedInput-notchedOutline': { borderColor: '#ECEDF2' },
                                            '& .MuiSelect-select': { py: { xs: '6px', sm: '8.5px' } },
                                        }}
                                    >
                                        {generateYearsToday(10)?.map((item, index) => (
                                            <MenuItem value={item} key={index}>{item}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box sx={{ display: 'flex', gap: 0.75 }}>
                                <Box
                                    onClick={() => {
                                        if (!isCurrentMonth) {
                                            const end = new Date(startDate);
                                            end.setMonth(end.getMonth() - 1);
                                            setStartDate(end);
                                            getAppointmentHoliday(end, selectedStaff);
                                        }
                                    }}
                                    sx={{
                                        width: 30, height: 30, display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        borderRadius: '8px', cursor: isCurrentMonth ? 'default' : 'pointer',
                                        background: '#FDF8FB', color: '#A72C68', border: '1px solid #F0CDDB',
                                        opacity: isCurrentMonth ? 0.4 : 1,
                                        '&:hover': isCurrentMonth ? {} : { background: '#F4DDE8' },
                                    }}
                                >
                                    <KeyboardArrowLeftIcon sx={{ fontSize: 18 }} />
                                </Box>
                                <Box
                                    onClick={() => {
                                        const end = new Date(startDate);
                                        end.setMonth(end.getMonth() + 1);
                                        setStartDate(end);
                                        getAppointmentHoliday(end, selectedStaff);
                                    }}
                                    sx={{
                                        width: 30, height: 30, display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        borderRadius: '8px', cursor: 'pointer',
                                        background: '#A72C68', color: '#fff', border: '1px solid #A72C68',
                                        '&:hover': { background: '#921F58' },
                                    }}
                                >
                                    <KeyboardArrowRightIcon sx={{ fontSize: 18 }} />
                                </Box>
                            </Box>
                        </Box>
                        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: { xs: '4px', sm: '6px' }, mb: 0.5 }}>
                            {['Mo','Tu','We','Th','Fr','Sa','Su'].map((d) => (
                                <Typography key={d} sx={{ fontSize: { xs: '10px', sm: '11px' }, fontWeight: 600, color: '#8a8d97', textAlign: 'center' }}>{d}</Typography>
                            ))}
                        </Box>
                        <Box>{panelWeeks}</Box>
                        {selectedFinalDate && (
                            <Box sx={{ mt: 2, p: 1.25, background: '#F7F8FB', border: '1px solid #ECEDF2', borderRadius: '10px', display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Box sx={{ width: 32, height: 32, borderRadius: '8px', background: '#F4DDE8', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                    <CalendarMonthIcon sx={{ color: '#A72C68', fontSize: 18 }} />
                                </Box>
                                <Box sx={{ flex: 1 }}>
                                    <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#A72C68', textTransform: 'uppercase', letterSpacing: '0.4px' }}>Selected Date</Typography>
                                    <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#1a1a2e' }}>{moment(selectedFinalDate).format('dddd, Do MMMM, YYYY')}</Typography>
                                    <Typography sx={{ fontSize: '11px', color: '#8a8d97' }}>Pick a time slot from the available slots.</Typography>
                                </Box>
                            </Box>
                        )}
                    </Grid>

                    {/* Right: Time slots */}
                    <Grid ref={ref} item xs={12}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.25 }}>
                            <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#1a1a2e' }}>Select Time</Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                <Typography sx={{ fontSize: '11px', color: '#8a8d97' }}>All times are in your local time</Typography>
                                <InfoOutlinedIcon sx={{ fontSize: 14, color: '#8a8d97' }} />
                            </Box>
                        </Box>
                        {appointmentSchedule?.success && selectedFinalDate ? (
                            <Box ref={scrollRef}>
                                {sectionDefs.map((section) => {
                                    const slots = appointmentSchedule?.[section.key] || [];
                                    return (
                                        <Box key={section.key} sx={{ mb: 1.5 }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, background: section.bg, borderRadius: '8px', px: 1, py: 0.5, mb: 1 }}>
                                                {section.icon}
                                                <Typography sx={{ fontSize: '12px', fontWeight: 700, color: section.color }}>{section.label}</Typography>
                                            </Box>
                                            {slots.length > 0 ? (
                                                <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'repeat(2, 1fr)', sm: 'repeat(3, 1fr)', md: 'repeat(4, 1fr)' }, gap: 0.75 }}>
                                                    {slots.map((item, index) => {
                                                        const isPicked = selectedTime?.slots?.[0] === item;
                                                        return (
                                                            <Button
                                                                key={index}
                                                                onClick={() => handleSelectedTime(appointmentSchedule?.slots, item)}
                                                                sx={{
                                                                    textTransform: 'none', borderRadius: '8px', py: 0.75,
                                                                    fontSize: '12px', fontWeight: 600,
                                                                    border: '1px solid', borderColor: isPicked ? section.color : `${section.color}55`,
                                                                    background: isPicked ? section.color : '#fff',
                                                                    color: isPicked ? '#fff' : section.color,
                                                                    boxShadow: isPicked ? `0 2px 6px ${section.color}33` : 'none',
                                                                    '&:hover': { background: isPicked ? section.color : section.bg, borderColor: section.color },
                                                                }}
                                                            >
                                                                {item}
                                                            </Button>
                                                        );
                                                    })}
                                                </Box>
                                            ) : (
                                                <Typography sx={{ fontSize: '12px', color: '#9ca3af', textAlign: 'center', py: 1 }}>All Booked</Typography>
                                            )}
                                        </Box>
                                    );
                                })}
                            </Box>
                        ) : (
                            <Typography sx={{ fontSize: '12px', color: '#9ca3af', textAlign: 'center', mt: 4 }}>Select a date to view available time slots.</Typography>
                        )}
                    </Grid>
                </Grid>
            );
        }

        return (
            <Grid container sx={{display: 'flex', justifyContent: 'space-between'}}>
                <Grid item xs={12} sx={{overflowX:{xs:'auto',sm:'unset'} }}>
                    <Box>
                        <Box
                            sx={{
                                display: 'flex',
                                p: {xs:'0',sm:'12px'},
                                justifyContent: 'space-between'
                            }}>
                            <Box sx={{display: 'flex', gap: '10px',ml:{xs:'10px',sm:'0'}}}>
                                <FormControl sx={{minWidth: 90}}>
                                    <Select
                                        size={"small"}
                                        value={startDate?.getMonth()}
                                        MenuProps={MenuProps}
                                        onChange={(e) => {
                                            const end = new Date(startDate);
                                            end.setMonth(e?.target?.value);
                                            setStartDate(end);
                                            getAppointmentHoliday(end, selectedStaff)
                                        }}
                                        sx={{
                                            background: '#F5DFEA',
                                            ".MuiOutlinedInput-notchedOutline": {
                                                borderWidth: "0!important"
                                            },
                                            "svg": {
                                                fontSize: '34px',
                                            }
                                        }}
                                    >
                                        {monthsArray?.length > 0 && monthsArray?.map((item, index) => (
                                            <MenuItem
                                                disabled={isDisabled(item?.key)}
                                                value={item?.key}
                                                key={index}
                                            >
                                                {item?.name}
                                            </MenuItem>
                                        ))
                                        }
                                    </Select>
                                </FormControl>
                                <FormControl sx={{minWidth: 90}}>
                                    <Select
                                        size={"small"}
                                        value={startDate?.getFullYear()}
                                        MenuProps={MenuProps}
                                        onChange={(e) => {
                                            const end = new Date(startDate);
                                            end.setFullYear(e?.target?.value);
                                            setStartDate(end);
                                            getAppointmentHoliday(end, selectedStaff)
                                        }}
                                        sx={{
                                            background: '#F5DFEA',
                                            ".MuiOutlinedInput-notchedOutline": {
                                                borderWidth: "0!important"
                                            },
                                            "svg": {
                                                fontSize: '34px',
                                            }
                                        }}
                                    >
                                        {generateYearsToday(10)?.length > 0 &&
                                            generateYearsToday(10)?.map((item, index) => (
                                                <MenuItem value={item} key={index}>{item}</MenuItem>
                                            ))
                                        }
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box sx={{display: 'flex', gap: '10px'}}>

                                <Box sx={isCurrentMonth ? {...boxStyle, ...disableStyle} : {...boxStyle}} onClick={() => {
                                    if (!isCurrentMonth) {
                                        const end = new Date(startDate);
                                        end.setMonth(end.getMonth() - 1);
                                        setStartDate(end); 
                                        getAppointmentHoliday(end, selectedStaff)
                                    }
                                }}>
                                    <KeyboardArrowLeftIcon sx={{fontSize: '32px'}}/>
                                </Box> 
                                <Box sx={boxStyle} onClick={() => {
                                    const end = new Date(startDate);
                                    end.setMonth(end.getMonth() + 1);
                                    setStartDate(end); 
                                    getAppointmentHoliday(end, selectedStaff)
                                }}>
                                    <KeyboardArrowRightIcon sx={{fontSize: '32px'}}/>
                                </Box>
                            </Box>
                        </Box>
                        <Box>
                            <Table aria-label="simple table" sx={{
                                boxShadow: 'none', "td , th": {
                                    tableLayout:"fixed",
                                    border: 'none',
                                    textAlign: 'center',
                                },
                                "th": {
                                    fontWeight: 'bold'
                                },
                                "td": {
                                    py: "4px"
                                }
                            }}> 
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Mo</TableCell>
                                        <TableCell>Tu</TableCell>
                                        <TableCell>We</TableCell>
                                        <TableCell>Th</TableCell>
                                        <TableCell>Fr</TableCell>
                                        <TableCell>Sa</TableCell>
                                        <TableCell>Su</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {weeks}
                                    <TableRow sx={{
                                        "td": {
                                            py: "5px!important"
                                        }
                                    }}>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Box>
                    </Box>
                </Grid>
                <Grid ref={ref}  item xs={12} sx={{display: "flex", flexDirection: 'column',}}>
                    <Box sx={{height: '64px', display: 'flex', alignItems: 'center'}}>
                        {selectedFinalDate ?
                            <Typography sx={{fontSize: '20px',fontFamily: "helvetica-lt-std-bold",  padding:{xs:"4px 7px"},}}>
                                {moment(selectedFinalDate).format('dddd, Do MMMM, YYYY')}
                            </Typography> : ""
                        }
                    </Box>
                    <Box


                        sx={{
                            display: "flex",
                            flexDirection: 'column',
                            alignItems: 'center',
                            width: '100%',
                        }}>
                        {appointmentSchedule?.success && selectedFinalDate &&
                            <Box ref={scrollRef}>
                                <Typography sx={{
                                    mt: '16px',
                                    mb: "8px",
                                    fontSize: '16px',
                                    fontFamily: "helvetica-lt-std-bold",
                                    padding:{xs:"4px 7px"},
                                }}>
                                    Morning
                                </Typography>
                                <Box sx={{ '@media (max-width:600px)':{
                                        display:'flex ',
                                        justifyContent:'center',
                                        flexWrap:'wrap'
                                    }, }}>
                                    {appointmentSchedule?.morningTimeSlots?.length > 0 ?
                                        appointmentSchedule?.morningTimeSlots.map((item, index) => (
                                            <Button
                                                key={index}
                                                variant={"outlined"}
                                                sx={{
                                                    color: selectedTime?.slots[0] === item ? '#006AFF' : '#fff',
                                                    backgroundColor: selectedTime?.slots[0] === item ? "#fff" : '#006AFF',
                                                    border: '1px solid #006AFF',
                                                    fontWeight: 'bold',
                                                    minWidth: {xs:'100px',sm:'140px'},
                                                    mr: '10px',
                                                    mb: '10px',
                                                    "&:hover": {
                                                        color: selectedTime?.slots[0] === item ? '#006AFF' : '#fff',
                                                        backgroundColor: selectedTime?.slots[0] === item ? "#fff" : '#006AFF',
                                                    }
                                                }}
                                                onClick={() => {
                                                    handleSelectedTime(appointmentSchedule?.slots, item);
                                                }}
                                            >
                                                {selectedTime?.slots[0] === item ? "✔" : ''} {item}
                                            </Button>

                                        ))
                                        : <Button
                                            disabled
                                            variant={"contained"}
                                            sx={{
                                                backgroundColor: '#fff',
                                                color: '#006AFF',
                                                fontFamily: "helvetica-lt-std-bold",
                                            }}
                                        >
                                            All Booked
                                        </Button>
                                    }
                                </Box>
                                <Typography
                                    sx={{
                                        mt: '16px',
                                        mb: "8px",
                                        fontSize: '16px',
                                        fontFamily: "helvetica-lt-std-bold",
                                        padding:{xs:"4px 7px"},
                                    }}
                                >
                                    Afternoon
                                </Typography>
                                <Box sx={{ '@media (max-width:600px)':{
                                        display:'flex ',
                                        justifyContent:'center',
                                        flexWrap:'wrap'
                                    }, }}>
                                    {appointmentSchedule?.afternoonTimeSlots?.length > 0 ?
                                        appointmentSchedule?.afternoonTimeSlots.map((item, index) => (
                                            <Button
                                                key={index}
                                                variant={"outlined"}
                                                sx={{
                                                    color: selectedTime?.slots[0] === item ? '#006AFF' : '#fff',
                                                    backgroundColor: selectedTime?.slots[0] === item ? "#fff" : '#006AFF',
                                                    border: '1px solid #006AFF',
                                                    fontWeight: 'bold',
                                                    minWidth: {xs:'100px',sm:'140px'},
                                                    mr: '10px',
                                                    mb: '10px',
                                                    "&:hover": {
                                                        color: selectedTime?.slots[0] === item ? '#006AFF' : '#fff',
                                                        backgroundColor: selectedTime?.slots[0] === item ? "#fff" : '#006AFF',
                                                    }
                                                }}
                                                onClick={() => {
                                                    handleSelectedTime(appointmentSchedule?.slots, item);
                                                }}
                                            >
                                                {selectedTime?.slots[0] === item ? "✔" : ''} {item}
                                            </Button>
                                        ))
                                        : <Button
                                            disabled
                                            variant={"contained"}
                                            sx={{
                                                backgroundColor: '#fff',
                                                color: '#006AFF',
                                                fontFamily: "helvetica-lt-std-bold",
                                            }}
                                        >
                                            All Booked
                                        </Button>
                                    }
                                </Box>
                                <Typography
                                    sx={{
                                        mt: '16px',
                                        mb: "8px",
                                        fontSize: '16px',
                                        fontFamily: "helvetica-lt-std-bold",
                                        padding:{xs:"4px 7px"},
                                    }}
                                >
                                    Evening
                                </Typography>
                                <Box sx={{ '@media (max-width:600px)':{
                                        display:'flex ',
                                        justifyContent:'center',
                                        flexWrap:'wrap'
                                    }, }}>
                                    {appointmentSchedule?.eveningTimeSlots?.length > 0 ?
                                        appointmentSchedule?.eveningTimeSlots.map((item, index) => (
                                            <Button
                                                key={index}
                                                variant={"outlined"}
                                                sx={{
                                                    color: selectedTime?.slots[0] === item ? '#006AFF' : '#fff',
                                                    backgroundColor: selectedTime?.slots[0] === item ? "#fff" : '#006AFF',
                                                    border: '1px solid #006AFF',
                                                    fontWeight: 'bold',
                                                    minWidth: {xs:'100px',sm:'140px'},
                                                    mr: '10px',
                                                    mb: '10px',
                                                    "&:hover": {
                                                        color: selectedTime?.slots[0] === item ? '#006AFF' : '#fff',
                                                        backgroundColor: selectedTime?.slots[0] === item ? "#fff" : '#006AFF',
                                                    }
                                                }}
                                                onClick={() => {
                                                    handleSelectedTime(appointmentSchedule?.slots, item);
                                                }}
                                            >
                                                {selectedTime?.slots[0] === item ? "✔" : ''} {item}
                                            </Button>
                                        ))
                                        : <Button
                                            disabled
                                            variant={"contained"}
                                            sx={{
                                                backgroundColor: '#fff',
                                                color: '#006AFF',
                                                fontFamily: "helvetica-lt-std-bold",
                                            }}
                                        >
                                            All Booked
                                        </Button>
                                    }
                                </Box>
                            </Box>}
                    </Box>
                </Grid>
            </Grid>
        );
    }
)

export default AppointmentTime;

